<template>
    <div class="hiring block lg:flex justify-between items-center flex-wrap gap-10">
        <div class="text-2xl text-blue-800">
            <i class="fa-solid fa-motorcycle" v-if="vehicle.vehicle_type === 'Motocicleta'"></i>
            <i class="fa-solid fa-car" v-else-if="vehicle.vehicle_type === 'Passeio'"></i>
            <i class="fa-solid fa-truck" v-else-if="vehicle.vehicle_type === 'Caminhão'"></i>
            <i class="fa-solid fa-circle-question" v-else></i>
        </div>
        
        <!-- Hiring Details -->
        <div class="grow text-sm flex justify-start items-center flex-wrap gap-10">
            <div class="min-w-[13%]">
                <p><b>Veículo:</b> {{ vehicle.model }}</p>
                <p><b>Ano:</b> {{ vehicle.year }}</p>
                <p><b>Cor:</b> {{ vehicle.color.toUpperCase() }}</p>
                <p><b>Placa:</b> {{ vehicle.plate }}</p>
                <p><b>Valor:</b> {{ getTotalPrice(vehicle.hiring?.hiring_price ?? 0.00) }}</p>
            </div>

            <div>
                <p><i class="w-4 text-end fa-solid fa-signal"></i> <b>Status:</b> <span class="text-green-500 font-bold">CONTRATADO</span></p>
                <p><i class="w-4 text-end fa-solid fa-calendar-days"></i> <b>Início da Contratação:</b> {{ dateService().formatBR(vehicle.hiring?.hiring_start) }}</p>
                <p><i class="w-4 text-end fa-solid fa-calendar-days"></i> <b>Fim da Contratação:</b> {{ dateService().formatBR(vehicle.hiring?.hiring_end) }}</p>
                <p><i class="w-4 text-end fa-solid fa-hourglass-half"></i> Faltam <b>{{ hiringDaysLeft + 1 }}</b> dias para encerrar seu plano</p>
            </div>

            <div class="grow text-md text-end">
                <button type="button" class="bg-blue-800 text-white rounded-lg py-1 px-3 btn-toggle-plus" :class="{ active: showDetails }" @click="toggleDetails">
                    <i class="fa-solid" :class="showDetails ? 'fa-minus' : 'fa-plus'"></i> Detalhes
                </button>
            </div>
        </div>

        <!-- Hiring Details Plus Toggle -->
        <div v-show="showDetails" class="toggle-details w-full bg-orange-100 text-neutral-600 p-4 rounded-lg text-sm mt-2">
            <div class="leading-6">
                <p><i class="fa-solid fa-bag-shopping"></i> <b>Plano Contratado:</b> {{ vehicle.hiring?.plan?.plan_name }}</p>
                <p><i class="fa-solid fa-dollar-sign"></i> <b>Valor do Plano:</b> {{ getTotalPrice(vehicle.hiring?.plan?.plan_price) }}</p>
                <p><i class="fa-solid fa-cash-register"></i> <b>Método de Pagamento:</b> {{ paymentMethodText(vehicle.hiring?.payment?.payment_method) }}</p>
                <p><i class="fa-solid fa-calendar-days"></i> <b>Data do Pagamento:</b> {{ dateService().formatBR(vehicle.hiring?.payment?.payment_date) }}</p>
                <p><i class="fa-solid fa-money-check-dollar"></i> <b>Status do Pagamento:</b> PAGO</p>
                <p><i class="fa-solid fa-money-check-dollar"></i> <b>Total:</b> {{ getTotalPrice(vehicle.hiring?.payment?.payment_total) }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import dateService from '@/services/dateService'
import stringService from '@/services/stringService'

export default {
    name: 'HiringExistsDashboard',
    props: {
        vehicle: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showDetails: false
        }
    },
    computed: {
        hiringDaysLeft() {
            const now = Date.now()
            return dateService.differenceInDays(now, this.vehicle.hiring?.hiring_end)
        }
    },
    methods: {
        getTotalPrice(price) {
            return stringService.formatPrice(price)
        },
        dateService() {
            return dateService
        },
        toggleDetails() {
            this.showDetails = !this.showDetails
        },
        paymentMethodText(method) {
            if (method === 'credit_card') return 'Cartão de Crédito'
            if (method === 'pix') return 'Pix'
            if (method === 'ticket') return 'Boleto'
            return 'Desconecido'
        }
    }
}
</script>
